import "./internal.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";
import { initButtons } from "./lib/buttons";
import { initScroll } from "./lib/scroll";
import { initSlideshows } from "./lib/slideshows";
import { simpleModal } from "./lib/simple-modal";
import { dynamicModal } from "./lib/dynamic-modal";
import { initFacetTweaks } from "./lib/facet-tweaks";
import { initTextFunctions } from "./lib/text-functions";
import { initAnnualDinnerCookie } from "./lib/cookie.js";
import { initPopup } from "./lib/popup.js";

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

document.addEventListener("DOMContentLoaded", function () {
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new BetterMenu();
	new BetterModal();

	new Fancybox.bind("[data-fancybox]", {
		closeButton: true,
		mainClass: "image-modal",
	});
		
	initButtons();
	initSlideshows();
	simpleModal();
	dynamicModal();
	initTextFunctions();
	// initAnnualDinnerCookie();
	initPopup();
	matchHeaderPlaceholder();

	if (document.querySelector(".panels")) {
		adjustLayout(".panels", ".panel");
	}
	initScroll();
	// initFacetTweaks();
});

const waitForElem = (selector) => {
	return new Promise((resolve) => {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}

		const observer = new MutationObserver((mutations) => {
			if (document.querySelector(selector)) {
				resolve(document.querySelector(selector));
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	});
};
const matchHeaderPlaceholder = () => {
	const header = document.querySelector(".site-header");
	const headerPlaceholder = document.querySelector(".placeholder-header");

	function updateHeight(size) {
		headerPlaceholder.dataset.windowSize = size;
		document.querySelector(".placeholder-header").style.height = header.offsetHeight + "px";
	}

	function checkBasedOnWindowSize() {
		if (window.innerWidth >= 992 && header.dataset.windowSize !== "large") {
			updateHeight("large");
		} else if (window.innerWidth < 992 && header.dataset.windowSize !== "small") {
			updateHeight("small");
		}
	}

	checkBasedOnWindowSize();
};
window.addEventListener("resize", function () {
	matchHeaderPlaceholder();
});
const adjustLayout = (containerSelector, itemSelector) => {
	const container = document.querySelector(containerSelector);
	const items = container.querySelectorAll(itemSelector);
	if (items.length === 1) {
		items[0].style.flexBasis = "100%"; // For Flexbox
		container.style.gridTemplateColumns = "1fr"; // For Grid
	}
};
